module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-image03-415x415@2x.1f580fb8.jpg";